export default "__VITE_ASSET__jbjTs$bm__"